"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorButton;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** MUI Button wrapper that shows errors in tooltip if provided */
function ErrorButton({
  errors,
  children,
  onClick,
  ...rest
}) {
  const hasErrors = errors ? typeof errors === 'string' ? true : errors.length : false;
  const singleError = errors ? typeof errors === 'string' ? errors : errors.length === 1 ? errors[0] : null : null;
  const multipleErrors = errors ? typeof errors === 'string' ? null : errors : null;
  const tooltipText = !hasErrors ? '' : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      color: "inherit",
      variant: "h6",
      children: "Hold up!"
    }), singleError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      color: "inherit",
      children: singleError
    }) : multipleErrors?.map((error, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      color: "inherit",
      children: error
    }, index))]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: tooltipText,
    arrow: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        variant: "contained",
        color: hasErrors ? 'inherit' : 'primary',
        onClick: hasErrors ? undefined : onClick,
        ...rest,
        children: children
      })
    })
  });
}